// extracted by mini-css-extract-plugin
export default {"modalDialog":"S7OzI0EB"};